import { createRequestTypes } from '../utils';

export const FETCH_PRODUCTS_FOR_SUBSTANCE = createRequestTypes('substanceProduct/FETCH_PRODUCTS_FOR_SUBSTANCE');
